import { PHONE_EXT_MAX_ERROR, POSTAL_CODE_ERROR, ZIP_LENGTH_ERROR } from 'src/common/validation/errors';

export const PHONE_EXT_MAX: [number, string] = [5, PHONE_EXT_MAX_ERROR];
export const ZIP_EXT_LENGTH: [number, string] = [5, ZIP_LENGTH_ERROR];

export const CANADA_POSTAL_CODE_REGEX = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
export const CANADA_POSTAL_CODE: [RegExp, string] = [CANADA_POSTAL_CODE_REGEX, POSTAL_CODE_ERROR];

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
